module.exports = __webpack_public_path__ + "img/levelSpacingWhite.9f74116a.svg";